import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, switchMap, take, takeUntil } from 'rxjs';
import { AlertMessageService } from './core/alert-message.service';
import { ErrorResponse } from './shared/models/general-responses.model';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  showAlert = false;
  showModal = false;
  messageInfo!: ErrorResponse;
  private destroy = new Subject<void>();

constructor(private alertMessageService: AlertMessageService, private messageService: NzMessageService,) {}
 
ngOnInit(): void {
  this.alertMessageService._currentAlert$.pipe(takeUntil(this.destroy)).subscribe((data) => {
    this.messageInfo = data;
    if(this.messageInfo && this.messageInfo.message) {
      this.showAlert = true;
    }

  });
}

  onClose() {
    this.showAlert = false;
  }
  
  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
